<template>
	<div class="date-time">
		<strong class="date">{{ formatDate(time) }}</strong> &middot;
		<span class="time">{{ formatTime(time) }}</span>
	</div>
</template>

<script>
import Column from '.'
import formatDate from '@/module/util/format-date'
import formatTime from '@/module/util/format-time'

export default {
	name: 'date-time-column',
	extends: Column,

	props: {
		time: {
			type: Number,
			required: true
		}
	},

	methods: {
		formatDate,
		formatTime
	}
}
</script>

<style lang="scss" scoped>
.date-time {
	font-size: 14px;
}
</style>
